<template>
    <div>
        <p v-show="this.loadingTable" class="text-center smaller">Poczekaj na dane</p>
        <v-server-table ref="table"
                        :columns="table.columns"
                        :options="table.options"
                        @row-click="rowClick"
                        @loading="handleLoading"
                        @loaded="handleLoaded"
                        v-show="!this.loadingTable">

          <div v-if="props.row.target" slot="target" slot-scope="props">
                <item-progress
                        :title="false"
                        :value="props.row.target.value"
                        suffix="%"
                        :bar="true"
                        :remaining="props.row.target.remaining"
                        size="small"
                        color="#ff0000">
                </item-progress>
            </div>
            <div v-if="props.row.uri" slot="uri" slot-scope="props" class="text-left">
                <div v-if="loadingRow && (props.row === currentRow)" class="loader-wrapper smaller" style="min-height: 28px; max-width: 28px"><span class="loader red"></span></div>
                <div v-else>
                    <a href="#" class="link nowrap" @click="saveFile(props.row.uri, 'raport-szczegółowy.xlsx')">
                        <svg><use xlink:href="#icon-details"></use></svg>
                    </a>
                </div>
            </div>
        </v-server-table>
    </div>
</template>

<script>
    import api from '@/services/Api';
    import ItemProgress from "../items/ItemProgress.vue"
    // import FileSaver from 'file-saver';
    import Save from '@/services/Save';

    export default {
        name: 'ServerTableComponent',
        components: { ItemProgress },
        props: ['url', 'params'],
        data() {
            return {
                loadingTable: false,
                loadingRow: false,
                currentRow: null,

                table: {
                    columns: [],
                    data: [],
                    options: {
                        requestFunction: (data) => {
//                            console.log('requestFunction:', data);
                            let params = this.params;
                            params['column'] = data.orderBy;
                            params['order'] = data.ascending ? 'asc' : 'desc';
                            params['page'] = data.page;
                            return api.get(this.url, { params: params })
                        },
                        responseAdapter: (res) => {
                           // console.log('responseAdapter:', res);

                            // table
                            this.table.options.headings = res.data.data.headings;
                            this.table.options.sortable = res.data.data.sortable;
                            this.table.columns = res.data.data.columns;

                            // selects
                            this.$parent.monthCollection = res.data.data.month;
                            this.$parent.quarterCollection = res.data.data.quarter;
                            this.$parent.yearCollection = res.data.data.year;
                            this.$parent.rsmCollection = res.data.data.rsm;
                            this.$parent.sellersCollection = res.data.data.sellers;
                            this.$parent.channelCollection = res.data.data.channel;

                            // special selects
                            this.$parent.superior = res.data.data.superior ? res.data.data.superior : null;
                            this.$parent.userTypeCollection = res.data.data.user_type ? res.data.data.user_type : null;
                            this.$parent.specialTypeCollection = res.data.data.special_type ? res.data.data.special_type : null;

                            // summary report
                            this.$parent.summaryReportUri = res.data.data.summaryReportUri;

                            // if response error
                            if(res.data.success === false){
                              return this.$ionic.toastController
                                .create({
                                  message: res.data.data,
                                  duration: 3000,
                                  mode: 'md',
                                  position: 'top'
                                })
                                .then(a => a.present());
                            }

                            // if response success
                            return {
                                data: res.data.data.data,
                                count: res.data.pager.total
                            }
                        },
                        skin: 'table',
                        perPage: 30,
                        headings: {},
                        sortable: [],
                        sortIcon: { base: 'sort-icon', up: 'sort-up', down: 'sort-down', is:'sort' },
                        filterable: false,
                        texts: {
                            noResults: 'Brak danych',
                            limit: 'Wyników',
                            loading: 'Poczekaj na dane',
                            count: '' // '{count} Wyniki'
                        }
                    }
                }
            }
        },
        methods: {
            getData() {
                this.$refs.table.refresh(); // must called by $ref - docs: https://www.npmjs.com/package/vue-tables-2#methods
            },
            handleLoading() {
                this.loadingTable = true;
            },
            handleLoaded() {
                this.loadingTable = false;
            },
            saveFile(uri, name) {
                this.loadingRow = true;
                api.get(uri).then(response => {
                    //FileSaver.saveAs(response.data, name);
                    Save.file(response, name, {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"})
                    this.loadingRow = false;
                }).catch(err => {
                    let error = err.message ? err.message : '';
                    this.$ionic.alertController
                        .create({
                            header: 'Błąd!',
                            message: 'Nie udało się pobrać pliku.<br/>'  + error,
                            buttons: ['OK'],
                            mode: 'md'
                        })
                        .then(a => a.present());
                    this.loadingRow = false;
                })
            },
            rowClick(data) {
                this.currentRow = data.row
            }
        }
    }
</script>
